import { render, staticRenderFns } from "./HolidayRow.vue?vue&type=template&id=884d10fe&scoped=true"
import script from "./HolidayRow.vue?vue&type=script&lang=js"
export * from "./HolidayRow.vue?vue&type=script&lang=js"
import style0 from "./HolidayRow.vue?vue&type=style&index=0&id=884d10fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884d10fe",
  null
  
)

export default component.exports